<template>
  <button
    class="text-base leading-5 text-EXPONDO-primary-80 underline"
    data-testid="ctClearRefinements"
    @click="clearFilters"
  >
    {{ $t('Clear filters') }}
  </button>
</template>

<script setup lang="ts">
// commercetools-native equivalent of ClearRefinements.vue, without ais-clear-refinements.
import { EVENT_SOURCE } from '~~/constants/googleTagManager';

defineOptions({ name: 'CtClearRefinements' });

const emit = defineEmits<{
  (event: 'clear'): void;
}>();

const route = useRoute();
const { trackClearAllFilters } = useGtmEvents();
const { getCurrentPageType } = usePageEventLocation();
const { getters: { currentCategoryName } } = useCategories();

const clearFilters = () => {

  const pageType = getCurrentPageType();
  const isCategoryListingPage = pageType === EVENT_SOURCE.CATEGORY_LISTING;

  trackClearAllFilters({
    categoryPath: isCategoryListingPage ? String(route.params.slug) : '',
    categoryName: isCategoryListingPage ? currentCategoryName.value : '',
    listingType: pageType,
  });
  emit('clear');

};
</script>
